export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const SET_SELECTED_PRODUCTS = "SET_SELECTED_PRODUCTS";

export const addProduct = (productId) => ({
  type: ADD_PRODUCT,
  payload: productId,
});

export const removeProduct = (productId) => ({
  type: REMOVE_PRODUCT,
  payload: productId,
});

export const setSelectedProduct = (productIds) => ({
  type: SET_SELECTED_PRODUCTS,
  payload: productIds,
});
